var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { DatagridConfigurable, List, TextField, ReferenceField, TextInput } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Typography } from "@mui/material";
import { generateRowClickHandler } from "../../services/RowClickService";
import { useTenantStore } from "../../providers/TenantContextProvider";
var OMIT_FIELDS = ["id", "ballot_eml"];
var Filters = [
    _jsx(TextInput, { label: "Ballot EML", source: "ballot_eml" }, 0),
    _jsx(TextInput, { label: "ID", source: "id" }, 1),
    _jsx(TextInput, { label: "Status", source: "status" }, 2),
    _jsx(TextInput, { source: "area_id" }, 3),
    _jsx(TextInput, { source: "election_event_id" }, 4),
    _jsx(TextInput, { source: "election_id" }, 5),
];
export var ListBallotStyle = function (_a) {
    var aside = _a.aside;
    var tenantId = useTenantStore()[0];
    var _b = React.useState(false), openDrawer = _b[0], setOpenDrawer = _b[1];
    var rowClickHandler = generateRowClickHandler(["election_event_id", "election_id", "area_id"]);
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "h5" }, { children: "Ballot Styles" })), _jsx(List, __assign({ actions: _jsx(ListActions, { open: openDrawer, setOpen: setOpenDrawer, withFilter: true }), sx: { flexGrow: 2 }, filter: {
                    tenant_id: tenantId || undefined,
                }, filters: Filters, aside: aside }, { children: _jsxs(DatagridConfigurable, __assign({ rowClick: rowClickHandler, omit: OMIT_FIELDS }, { children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "ballot_eml" }), _jsx(TextField, { source: "status" }), _jsx(ReferenceField, __assign({ label: "Area", reference: "sequent_backend_area", source: "area_id" }, { children: _jsx(TextField, { source: "name" }) })), _jsx(ReferenceField, __assign({ label: "Election", reference: "sequent_backend_election", source: "election_id" }, { children: _jsx(TextField, { source: "name" }) })), _jsx(ReferenceField, __assign({ label: "Election Event", reference: "sequent_backend_election_event", source: "election_event_id" }, { children: _jsx(TextField, { source: "name" }) })), _jsx(ReferenceField, __assign({ source: "area_id", reference: "sequent_backend_area" }, { children: _jsx(TextField, { source: "name" }) }))] })) }))] }));
};
